import React from "react";

import { useHover } from "@mantine/hooks";
import { IconButton } from "@mui/material";
import Fade from "@mui/material/Fade";
import { colors } from "@zapalacorp/tokens";
import { CloseIcon } from "../../icons";

import { ContainerLabel, ContainerSubItem, Tooltip } from "./styled";

interface ResourceSlotSubItemProps {
  children?: React.ReactNode;
  title?: string;
  text?: string;
  tooltipText?: string;
  forceHouver?: boolean;
  hasTooltip?: boolean;
  hasError?: boolean;
  hasDeleteButton?: boolean;
  deleteButtonProps?: {
    disabled?: boolean;
    disabledTooltip?: string;
  };
  onDeleteClick?: () => void;
  disableHouver?: boolean;
}

export const ResourceSlotSubItem = (props: ResourceSlotSubItemProps) => {
  const {
    title,
    text,
    children,
    hasError,
    hasDeleteButton,
    deleteButtonProps = {},
    onDeleteClick,
    disableHouver,
    hasTooltip,
    tooltipText,
    forceHouver,
  } = props;
  const { hovered: isHovering, ref } = useHover();

  const renderLabel = () => {
    if (!title && !text) return;

    return (
      <ContainerLabel>
        {title && <strong>{title}</strong>}
        {text}
      </ContainerLabel>
    );
  };

  const renderDeleteButotn = () => {
    if (!hasDeleteButton) return null;
    const { disabled, disabledTooltip } = deleteButtonProps;

    return (
      <Fade in={isHovering}>
        <div style={{ width: "20px", height: "20px" }}>
          <Tooltip title={disabled ? disabledTooltip : ""} disableInteractive>
            <div>
              <IconButton
                size="small"
                sx={{
                  marginLeft: "auto",
                  padding: "0 !important",
                  color: disabled ? colors.gray300 : colors.gray600,
                }}
                onClick={onDeleteClick}
                color="inherit"
                disabled={disabled}
              >
                <CloseIcon />
              </IconButton>
            </div>
          </Tooltip>
        </div>
      </Fade>
    );
  };

  const renderContent = () => {
    return (
      <ContainerSubItem
        disableHouver={disableHouver}
        hasError={hasError}
        forceHouver={forceHouver}
        ref={ref}
      >
        {renderLabel()}

        {children}

        {renderDeleteButotn()}
      </ContainerSubItem>
    );
  };

  if (hasTooltip) {
    return (
      <Tooltip title={tooltipText} placement="top" disableInteractive>
        {renderContent()}
      </Tooltip>
    );
  }

  return renderContent();
};
